var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module__edit_versions"},[_c('component-list',{attrs:{"component-table":_vm.ModuleEditVersionsTable,"item-name":['version', 'versions'],"filters-active":false,"get-items-getter":'getEbsModuleVersions'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }